import { render, staticRenderFns } from "./ClassifiedSeries.vue?vue&type=template&id=02b4b1fe&"
import script from "./ClassifiedSeries.vue?vue&type=script&lang=js&"
export * from "./ClassifiedSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports